import styled from "styled-components";


export const CalendarStyle = styled.div`


.react-calendar{
border:0;
   @media all and (max-width: 768px) {
    width: 100%!important;
  }
}




/* ~~~ navigation styles ~~~ */
.react-calendar__navigation {
    display: flex;

    .react-calendar__navigation__label {
      font-weight: bold;
    }

    .react-calendar__navigation__arrow {
      flex-grow: 0.333;
    }
  }
    /* ~~~ day grid styles ~~~ */
  .react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: 14.2% 14.2% 14.2% 14.2% 14.2% 14.2% 14.2%; 

    .react-calendar__tile {
    padding: 10px 0;
      max-width: initial !important;
    }
  }
  /* ~~~ button styles ~~~ */
  button {
    margin: 3px;
    border: 0;
    border-radius: 3px;
    color: #333;
    background-color: transparent!important;

    &:hover {
      background-color: #4f39f6;
       abbr{
          background-color: #333;
            padding: 1rem;
            color: #fff;
    }
    }

    &:active {
      background-color: #4f39f6;
    }
  }
     /* ~~~ active day styles ~~~ */
  .react-calendar__tile--range {
      background-color: #333!important;
      abbr{
          background-color: #333;
            padding: 1rem;
            color: #fff;
    }
  }
      



`;